import { appBarMeta } from "@constants/appbar";
import { events } from "@constants/tracking";
import { useAuthContext } from "@features/auth/contexts/AuthContext";
import { FeedbackDialog } from "@features/feedback/components/dialogs/FeedbackDialog";
import { defaultFeedbackSubtitle } from "@features/feedback/constants";
import { isWeb } from "@helpers/platform";
import { useCustomNavigation } from "@hooks/useCustomNavigation";
import { useDevice } from "@hooks/useDevice";
import CustomAppbar from "@memorang/ui/src/components/CustomAppbar";
import Loader from "@memorang/ui/src/components/Loader";
import { trackCustomEvent } from "analytics";
import DocumentTitle from "components/DocumentTitle";
import { router, usePathname } from "expo-router";
import { useState } from "react";
import { useTranslation } from "react-i18next";

type ProgressLoadingContainerProps = {
	onFeedbackToggle: () => void;
};

const ProgressLoadingContainer = ({
	onFeedbackToggle,
}: ProgressLoadingContainerProps) => {
	const [showFeedbackDialog, setShowFeedbackDialog] = useState(false);
	const { handleFeedbackNavigation } = useCustomNavigation();
	const { newUserInfo } = useAuthContext();
	const pathname = usePathname();
	const { t } = useTranslation();
	const { isMobile } = useDevice();

	const toggleShowFeedbackDialog = () => {
		setShowFeedbackDialog((prev) => !prev);
		onFeedbackToggle();
	};

	return (
		<>
			<CustomAppbar
				handleTrackEvent={() => {
					trackCustomEvent({
						eventName: events.commandBarClicked,
						option: "command_bar",
					});
				}}
				handleFeedbackNavigation={() =>
					handleFeedbackNavigation(toggleShowFeedbackDialog)
				}
				onBackPress={() => {
					if (router.canGoBack()) {
						router.back();
					} else {
						router.push("/(protected)/(tabs)/home");
					}
				}}
				onAvatarPress={() => router.push("/(protected)/account/settings")}
				{...(newUserInfo && {
					userInfo: {
						firstName: newUserInfo.firstName || newUserInfo.name,
						lastName: newUserInfo.lastName,
					},
				})}
				showHambugerMenu={true}
				showCommandBar={isWeb}
				role="banner"
				options={{
					headerTitle: t(appBarMeta.progress.title),
					subtitle: isMobile ? "" : appBarMeta.progress.description,
				}}
			/>
			<DocumentTitle title="Progress" />
			<Loader />
			{isWeb && (
				<FeedbackDialog
					visible={showFeedbackDialog}
					view={pathname}
					feedbackSubtitle={t(defaultFeedbackSubtitle)}
					handleDismiss={toggleShowFeedbackDialog}
				/>
			)}
		</>
	);
};

export default ProgressLoadingContainer;
